export const SwapFormDecimalPad = (): null => {
  return null
}
